document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        setTimeout(function () {
          entry.target.classList.add('mt-visible');
        }, (entry.target.dataset.mtDelay || 0) * 1);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el, i) {
    el.dataset.mtDelay = (i % 4) * 90;
    observer.observe(el);
  });
}

function initGaleriaProducto() {
  var principal = document.querySelector('[data-mt-galeria-principal]');
  var minis = document.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !minis.length) return;
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var url = mini.getAttribute('data-mt-full');
      principal.src = url;
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initVariantesProducto() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio-actual]');
  var precioAnteriorEl = document.querySelector('[data-mt-precio-anterior]');
  var btn = form.querySelector('[data-mt-anadir-btn]');
  var avisoEl = document.querySelector('[data-mt-stock-aviso]');
  var stockEl = document.querySelector('[data-mt-stock-estado]');
  var botones = document.querySelectorAll('[data-mt-opcion-valor]');
  var galeriaPrincipal = document.querySelector('[data-mt-galeria-principal]');
  var miniaturas = document.querySelectorAll('[data-mt-miniatura]');

  function seleccionActual() {
    var seleccion = {};
    document.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-seleccionada');
      if (activo) seleccion[grupo.getAttribute('data-mt-opcion')] = activo.getAttribute('data-mt-opcion-valor');
    });
    return seleccion;
  }

  function encontrarVariante() {
    var seleccion = seleccionActual();
    return variantes.find(function (v) {
      return v.opciones.every(function (val, i) {
        return seleccion[v.nombresOpciones[i]] === val;
      });
    });
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString('es-ES', { style: 'currency', currency: 'EUR' });
  }

  function actualizarStock(variante) {
    if (!stockEl) return;
    var textoOk = stockEl.getAttribute('data-mt-stock-ok-texto') || 'Disponible';
    var textoAgotado = stockEl.getAttribute('data-mt-stock-agotado-texto') || 'Agotado';

    if (variante.disponible) {
      stockEl.innerHTML = '<span class="mt-stock-ok">✅ ' + textoOk + '</span>';
    } else {
      stockEl.innerHTML = '<span class="mt-stock-agotado">❌ ' + textoAgotado + '</span>';
    }
  }

  function actualizar() {
    var variante = encontrarVariante();
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) precioEl.textContent = formatearDinero(variante.precio);
    if (precioAnteriorEl) {
      if (variante.precioAnterior && variante.precioAnterior > variante.precio) {
        precioAnteriorEl.textContent = formatearDinero(variante.precioAnterior);
        precioAnteriorEl.style.display = '';
      } else {
        precioAnteriorEl.style.display = 'none';
      }
    }
    if (galeriaPrincipal && variante.imagen) {
      galeriaPrincipal.src = variante.imagen;
      if (variante.imagenAlt) {
        galeriaPrincipal.alt = variante.imagenAlt;
      }
      miniaturas.forEach(function (mini) {
        var esLaMisma = mini.getAttribute('data-mt-full') === variante.imagen;
        mini.classList.toggle('mt-activa', esLaMisma);
      });
    }
    actualizarStock(variante);
    if (variante.disponible) {
      btn.disabled = false;
      btn.textContent = btn.getAttribute('data-mt-texto-disponible');
      if (avisoEl) avisoEl.style.display = 'none';
    } else {
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-mt-texto-agotado');
      if (avisoEl) avisoEl.style.display = '';
    }
  }

  botones.forEach(function (boton) {
    boton.addEventListener('click', function () {
      if (boton.disabled) return;
      var grupo = boton.closest('[data-mt-opcion]');
      grupo.querySelectorAll('[data-mt-opcion-valor]').forEach(function (b) { b.classList.remove('mt-seleccionada'); });
      boton.classList.add('mt-seleccionada');
      actualizar();
    });
  });

  actualizar();
}
